<template>
  <div class="ui-accordion">
    <ui-accordion-item
      v-for="item in items"
      :key="item.id"
      :title="item.title"
      :content="item.description"
    />
  </div>
</template>

<script>
import UiAccordionItem from './ui-accordion-item';

export default {
  name: 'ui-accordion',
  components: {
    UiAccordionItem
  },

  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
};
</script>

<style lang="scss">
.ui-accordion {
  //
}
</style>